angular.module('leanlaw').filter("invoiceOptions", ['$filter', function ($filter) {
  return function (options, me, invoice, codesExpenseAttachments) {
    return options.filter(o => {
      if (o.isMultiInvoiceOption) return false;
      if (o.show && !o.show(me, invoice, codesExpenseAttachments)) return false;

      // Hide QBO-dependent actions for orphan billed invoices
      if (invoice && invoice.isOrphanBilled && o.actions) {
        if (o.actions.submit || o.actions.send || o.actions.emailCustomization || o.actions.pay || o.actions.trust || o.actions.groupInvoiceEmail) {
          return false;
        }
      }
      return true;
    });
  };
}]);